import { createSelector } from 'reselect'
import { filter, get, sortBy } from 'lodash'
import { selectAllFields } from '@reducers/data/field'

export const getFieldsForTable = createSelector(
  (_, props) => props.tableId,
  state => selectAllFields(state),
  function (tableId, allFields) {
    return filter(allFields, field => {
      const fieldTableId = get(field, ['attributes', 'table_id'])
      return fieldTableId.toString() === tableId.toString()
    })
  }
)

// sorts fields by primary, then by order
export const getSortedFields = createSelector([getFieldsForTable], fields =>
  sortBy(fields, [
    field => !field.attributes.primary, // Negate the boolean so `true` comes first
    field => field.attributes.position,
  ])
)

export const getSortedFieldsById = createSelector([getSortedFields], fields => sortBy(fields, field => field.id))

// gets fields that are sortable
export const getSortableFieldsForTable = createSelector([getFieldsForTable], fields =>
  filter(fields, field => field.attributes?.sortable || false)
)
